(function () {
  var sliders = Array.prototype.slice.call(document.querySelectorAll('.erawish-main-slider'));
  if (!sliders.length) return;

  sliders.forEach(function (slider) {
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.erawish-slide'));
    if (slides.length < 2) return;

    var previous = slider.querySelector('.erawish-slider-prev');
    var next = slider.querySelector('.erawish-slider-next');
    var dots = Array.prototype.slice.call(slider.querySelectorAll('.erawish-slider-dot'));
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var index = 0;
    var timer;

    function setActive(nextIndex) {
      slides[index].classList.remove('is-active');
      index = (nextIndex + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      slides.forEach(function (slide, slideIndex) {
        var isActive = slideIndex === index;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (isActive) slide.removeAttribute('tabindex');
        else slide.setAttribute('tabindex', '-1');
      });
      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function start() {
      stop();
      if (reduceMotion.matches || document.hidden) return;
      timer = window.setInterval(function () {
        setActive(index + 1);
      }, 4200);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
    }

    slides.forEach(function (slide, slideIndex) {
      slide.classList.toggle('is-active', slideIndex === 0);
      slide.setAttribute('aria-hidden', slideIndex === 0 ? 'false' : 'true');
      if (slideIndex === 0) slide.removeAttribute('tabindex');
      else slide.setAttribute('tabindex', '-1');
    });
    dots.forEach(function (dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === 0);
      dot.setAttribute('aria-current', dotIndex === 0 ? 'true' : 'false');
      dot.addEventListener('click', function () {
        setActive(dotIndex);
        start();
      });
    });

    if (previous) {
      previous.addEventListener('click', function () {
        setActive(index - 1);
        start();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        setActive(index + 1);
        start();
      });
    }

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', function (event) {
      if (!slider.contains(event.relatedTarget)) start();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });
    if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', start);
    start();
  });
})();

(function () {
  var rails = Array.prototype.slice.call(document.querySelectorAll('.erawish-product-rail-shell, .erawish-info-rail-shell'));
  if (!rails.length) return;

  function updateButtons(grid, previous, next) {
    var maxScroll = grid.scrollWidth - grid.clientWidth - 2;
    if (previous) previous.classList.toggle('is-disabled', grid.scrollLeft <= 2);
    if (next) next.classList.toggle('is-disabled', grid.scrollLeft >= maxScroll);
  }

  rails.forEach(function (rail) {
    var grid = rail.querySelector('.erawish-product-grid--scroll, .erawish-info-grid');
    var previous = rail.querySelector('.erawish-rail-prev');
    var next = rail.querySelector('.erawish-rail-next');
    if (!grid) return;

    function step(direction) {
      var card = grid.querySelector('.erawish-product-card, .erawish-info-card');
      var cardWidth = card ? card.getBoundingClientRect().width : grid.clientWidth * 0.8;
      var gap = parseFloat(window.getComputedStyle(grid).columnGap || window.getComputedStyle(grid).gap || '0') || 0;
      var visibleCards = Math.max(1, Math.floor(grid.clientWidth / Math.max(1, cardWidth + gap)));
      grid.scrollBy({ left: direction * (cardWidth + gap) * visibleCards, behavior: 'smooth' });
    }

    if (previous) {
      previous.addEventListener('click', function () {
        step(-1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        step(1);
      });
    }

    grid.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        updateButtons(grid, previous, next);
      });
    }, { passive: true });

    window.addEventListener('resize', function () {
      updateButtons(grid, previous, next);
    });

    updateButtons(grid, previous, next);
  });
})();

(function () {
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.template-index .erawish-spigen-home [data-erawish-track]');
    if (!link || !window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return;

    var section = link.closest('section');
    var heading = section && section.querySelector('h2');
    var cards = section ? Array.prototype.slice.call(section.querySelectorAll('[data-erawish-track="product"]')) : [];
    var position = link.dataset.erawishPosition || (cards.indexOf(link) + 1 || undefined);
    var publication = Shopify.analytics.publish('erawish:homepage_click', {
      interaction_type: link.dataset.erawishTrack,
      label: link.dataset.erawishLabel,
      section: heading ? heading.textContent.trim() : 'Hero',
      position: position,
      destination: link.getAttribute('href')
    });

    if (publication && typeof publication.catch === 'function') publication.catch(function () {});
  });
})();
